"use strict";

var _classCallCheck = require("/Users/shofmann/Documents/git/js/xkcdpwa/node_modules/@babel/runtime/helpers/classCallCheck");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Seismograph = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var Seismograph = function Seismograph() {
  var _this = this;

  _classCallCheck(this, Seismograph);

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    minShakes: 3,
    minAmplitude: 3,
    onShake: function onShake() {
      return "EAAAARTHQUAAAAKEEE!";
    },
    delay: 1500
  },
      minShakes = _ref.minShakes,
      minAmplitude = _ref.minAmplitude,
      onShake = _ref.onShake,
      delay = _ref.delay;

  (0, _defineProperty2.default)(this, "startRecording", function () {
    window.addEventListener("devicemotion", _this._onMotionEvent);
  });
  (0, _defineProperty2.default)(this, "stopRecording", function () {
    window.removeEventListener("devicemotion", _this._onMotionEvent);
  });
  (0, _defineProperty2.default)(this, "_onMotionEvent", function (event) {
    var x = null;

    if ("acceleration" in event) {
      x = event.acceleration.x;
    } else {
      x = event.accelerationIncludingGravity.x;
    }

    _this._initValues(x);

    _this._detectShake(x, _this.previousX);
  });
  (0, _defineProperty2.default)(this, "_initValues", function (x) {
    if (!_this.previousX) {
      _this.previousX = x;
    }
  });
  (0, _defineProperty2.default)(this, "_detectShake", function (current, previous) {
    if (_this._belowTimeThreshold()) {
      return false;
    }

    if (!_this._checkAmplitude(current, previous)) {
      return false;
    } else {
      ++_this.currentShakes;
    }

    previous = current;

    if (_this._shakeThresholdReached()) {
      _this.currentShakes = 0;
      _this.lastShake = _this._currentDate();

      _this.onShake();

      return true;
    }

    return false;
  });
  (0, _defineProperty2.default)(this, "_checkAmplitude", function (current, previous) {
    if (Math.sign(current) === Math.sign(previous) || Math.abs(current) < _this.minAmplitude) {
      return false;
    }

    return true;
  });
  (0, _defineProperty2.default)(this, "_shakeThresholdReached", function () {
    return _this.currentShakes > _this.minShakes;
  });
  (0, _defineProperty2.default)(this, "_belowTimeThreshold", function () {
    return _this._currentDate() - _this.lastShake < _this.delay;
  });
  (0, _defineProperty2.default)(this, "_currentDate", function () {
    return Date.now();
  });

  if (typeof minShakes === "number" && minShakes > 0) {
    this.minShakes = minShakes;
  } else {
    this.minShakes = 3;
  }

  if (typeof minAmplitude === "number" && minAmplitude > 0) {
    this.minAmplitude = minAmplitude;
  } else {
    this.minAmplitude = 3;
  }

  if (typeof onShake === "function") {
    this.onShake = onShake;
  } else {
    this.onShake = function () {
      return "EAAAARTHQUAAAAKEEE!";
    };
  }

  this.delay = delay > 0 ? delay : 1500;
  this.currentShakes = 0;
  this.lastShake = Date.now();
  this.previousX = null;
};

exports.Seismograph = Seismograph;